/* eslint-disable no-unused-vars */
/*global kakao*/
import React, { useEffect, useRef, useState } from "react";
import CommonNav from "../main/CommonNav";
import LoadingUI from "../lib/LoadingUI";
import StoreList from "./components/StoreList";
import StoreSummaryData from "./components/StoreSummaryData";
import StoreImageSlide from "./components/StoreImageSlide";
import StoreDetailContact from "./components/StoreDetailContact";
import StoreReview from "./components/StoreReview";

import BuddibleSocket, { MsgIDList } from "../lib/BuddibleSocket";
import Utilities from "../lib/Utilities";
import CodeList from "../lib/CodeList";
import StoreMallMap from "./components/StoreMallMap";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

const socket = new BuddibleSocket();
const util = new Utilities();
const codeList = new CodeList();

const _mClassName = "StoreMallMain";
let storeData = [];

export default function StoreMallMain() {
  const param = useParams();
  const [loginInfo, setLoginInfo] = useState(null);
  const [loading, setLoading] = useState(false);
  const [storeList, setStoreList] = useState([]);
  const [isStoreListView, setIsStoreListView] = useState(true);
  const [selectedStore, setSelectedStore] = useState(null);
  const [isSearchWord, setIsSearchWord] = useState("");
  const [wordFilter, setWordFilter] = useState("");
  const [isImageSlideView, setIsImageSlideView] = useState(false);
  const [imageSlideIndex, setImageSlideIndex] = useState(0);
  const [isContactView, setIsContactView] = useState(false);
  const [currentView, setCurrentView] = useState(0); //0:데스크탑, 1: 테블릿, 2:모바일
  const [isMobileListView, setIsMobileListView] = useState(false);
  const [navHeight, setNaveHeight] = useState(56);
  const isLogiWork = window.location.pathname.startsWith("/freiscop");
  //-------review-----------
  const [storeReviewList, setStoreReviewList] = useState([
    {
      srIDX: "1", // 리뷰관리번호
      srKey: "", // 스토어 키
      srUserName: "테스트", // 리뷰자 성명
      srUserCompCD: "Z0001", // 리뷰자 업체코드
      srUserID: "buddible@buddible.com", // 리뷰자 아이디
      srRating: "4", // 리뷰점수
      srReviewText:
        "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Dolore doloremque eius labore officiis optio qui quia sunt suscipit? Consequatur eveniet hic libero rerum vel veritatis? Animi corporis culpa delectus dolore dolorem ea earum error, illo inventore laboriosam, maxime natus odio pariatur placeat quibusdam soluta unde! Assumenda dolorum incidunt repellendus sapiente!", // 리뷰내용
      srReviewPWD: "", // 리뷰 비밀번호
      srCreateDate: new Date().toLocaleDateString(), // 작성일
      srEditDate: new Date().toLocaleDateString(), // 수정일
      srShowYN: "N", // 노출여부
    },
  ]);
  const { t, i18n } = useTranslation();
  const $search_word = useRef();
  const $store_url = useRef();

  (() => {
    socket.addLocalEventListener(
      MsgIDList.EVENT_LOGIN_AUTO_SUCCESS,
      _mClassName,
      (b, n) => {
        if (!n) return;
        if (!n["returnData"].length) return;
        setLoginInfo(n["returnData"][0]);
      }
    );
    socket.addLocalEventListener(
      MsgIDList.EVENT_SOCKET_DATA_ERROR,
      _mClassName,
      (b, n) => {
        setLoading(false);
      }
    );
  })();

  useEffect(() => {
    resizeLayout();
    window.addEventListener("resize", resizeLayout);
    i18n.changeLanguage(i18n.language, (err) => {
      console.log(err);
    });

    let userData = socket.getLocalDataSet(MsgIDList.EVENT_LOGIN_AUTO_SUCCESS);
    if (userData) {
      if (userData["returnData"].length) {
        setLoginInfo(userData["returnData"][0]);
      }
    }
    if (param.store_key) {
      $search_word.current.value = param.store_key;
      searchStore();
    }

    return () => {
      window.removeEventListener("resize", resizeLayout);

      socket.removeLocalEventListener(
        MsgIDList.EVENT_LOGIN_AUTO_SUCCESS,
        _mClassName
      );
      socket.removeLocalEventListener(
        MsgIDList.EVENT_SOCKET_DATA_ERROR,
        _mClassName
      );
    };
  }, []);

  //화면 타입 핸들러 0 :PC, 1 : 테블릿, 2 :모바일
  function resizeLayout() {
    let innerWindow = window.innerWidth;
    if (innerWindow > 1600) {
      setCurrentView(0);
    } else if (innerWindow <= 1600 && innerWindow > 900) {
      setCurrentView(1);
    } else {
      setCurrentView(2);
    }
    setNaveHeight(
      document.getElementById("plain")
        ? document.getElementById("plain").offsetHeight
        : 0
    );
  }

  //창고 검색
  function searchStore() {
    let value = $search_word.current.value;
    setLoading(true);
    setWordFilter(value);
    setIsSearchWord(value);
    getStoreListByKeyword(value);
  }

  //카카오 지도에 검색어 전달
  function getStoreListByKeyword(keyword) {
    socket.sendLocalMessage(
      MsgIDList.EVENT_CUSTOMS_STORE_KEYWORD_CHANGED,
      _mClassName,
      { keyword: keyword },
      () => {}
    );
  }

  //보세창고 선택 및 자세히보기
  function showSelectedStoreDetail(value) {
    let storeData = {};
    for (let key in value) {
      if (
        key !== "sdTypeKind" &&
        key !== "sdTypeGoods" &&
        key !== "sdPhoto" &&
        key.indexOf("Contact") === -1
      ) {
        storeData[key] = value[key] ? value[key] : "-";
      } else {
        storeData[key] = value[key] ? value[key] : "";
      }
    }
    setIsStoreListView(false);
    setSelectedStore(storeData);
  }

  //선택 창고 디테일 닫기
  function clearSelectedStore() {
    window.location.hash = "";
    setIsStoreListView(true);
    setSelectedStore(null);
  }

  //창고 요약정보 닫기(PC 기준 좌측)
  function closeSummaryStoreData() {
    window.location.hash = "";
    setIsStoreListView(true);
  }

  //지도 기반 창고목록 변경
  function changeStoreList(value) {
    setLoading(false);
    setWordFilter("");
    if (Array.isArray(value)) {
      storeData = [...value];
      setStoreList(value);
    }
  }

  useEffect(() => {
    document.getElementById("btn-lang").style.display = "";
    if (selectedStore !== null) {
      document.getElementById("btn-lang").style.display = "none";
      SELECT_STORE_REVIEW(selectedStore);
    }
  }, [selectedStore]);

  //창고 리뷰 요청
  function SELECT_STORE_REVIEW(store) {
    const msgID = util.makeUUIDv4();
    const socketMsg = {
      file: "/customsStore/review/JS_store_review_select.php",
      msgID: msgID,
      data: {},
      srKey: store.smKey, //store.smKey,
      srShowYN: "Y",
    };
    setLoading(true);
    socket.sendMessage(socketMsg, msgID, (beforeData, newData) => {
      if (newData) {
        if (newData.ret) {
          handleReviewDataList(newData["returnData"]);
          setLoading(false);
        }
      }
    });
  }

  //리뷰 데이터 가공
  function handleReviewDataList(reviewList) {
    let dataList = [];
    for (let i = 0; i < reviewList.length; i++) {
      let review = reviewList[i];
      review.isShow =
        review.srKey === loginInfo["COMP_C_NUM"] ||
        review.srUserID === loginInfo["user_id"] ||
        review.srPublicYN === "Y";
      dataList.push(review);
    }
    setStoreReviewList(dataList);
  }

  useEffect(() => {
    if (storeList.length > 0) {
      if (window.location.hash) {
        let hashDataKey = window.location.hash.split("?")[0].split("#");
        hashDataKey = hashDataKey[1];
        let dataList = [...storeList];
        let selectedStore = dataList.find((data) => data.smKey === hashDataKey);
        showSelectedStoreDetail(selectedStore);
      }
    }
  }, [storeList, isStoreListView, wordFilter]);

  //창고 이미지 슬라이드 이동
  function changeImageSlideIndex(index) {
    setImageSlideIndex(index);
  }

  //창고 이미지 슬라이드 열기
  function openImageSlide(index) {
    changeImageSlideIndex(index);
    setIsImageSlideView(true);
  }

  //창고 이미지 슬라이드 닫기
  function closeImageSlide() {
    setImageSlideIndex(0);
    setIsImageSlideView(false);
  }

  //지도 창고 마커 클릭
  function clickMapMaker(storeKey) {
    let storeListData = [...storeData];
    let getStore = storeListData.find((data) => data.smKey === storeKey);
    if (getStore) {
      showSelectedStoreDetail(getStore);
    } else {
      console.log("clickMapMaker 창고정보 못찾음", getStore);
    }
  }

  //창고 문의정보 전송
  function INSERT_STORE_INQUIRY(uploadData) {
    if (!checkValidation(uploadData)) return;
    const msgID = util.makeUUIDv4();
    const socketMsg = {
      file: "/customsStore/JS_store_request_insert.php",
      msgID: msgID,
      data: {},
      ...uploadData,
    };
    setLoading(true);
    socket.sendMessage(socketMsg, msgID, (beforeData, newData) => {
      if (newData) {
        const msg = newData.ret
          ? t("storeMall.storeList.msg.successInquiry")
          : t("commonMSG.error");
        codeList.Modal.current.alert(msg);
        setLoading(false);
      }
    });
  }

  function checkValidation(uploadData) {
    if (uploadData.srType.trim() === "") {
      codeList.Modal.current.alert(
        t("storeMall.storeList.msg.enterInquiryType")
      );
      return false;
    }
    if (uploadData.srUserName.trim() === "") {
      codeList.Modal.current.alert(
        t("storeMall.storeList.msg.enterInquiryName")
      );
      return false;
    }
    if (uploadData.srEmail.trim() === "") {
      codeList.Modal.current.alert(
        t("storeMall.storeList.msg.enterInquiryEmail")
      );
      return false;
    }
    if (uploadData.srMobile.trim() === "") {
      codeList.Modal.current.alert(
        t("storeMall.storeList.msg.enterInquiryTel")
      );
      return false;
    }

    return true;
  }

  //창고 url 복사
  function copyUrl() {
    let dummy = document.createElement("input");
    let text = `https://freiscop.gbts.co.kr/storeMall/${selectedStore.smKey}`;
    document.body.appendChild(dummy);
    dummy.value = text;
    dummy.select();
    document.execCommand("copy");
    document.body.removeChild(dummy);
    codeList.Modal.current.alert(t("storeMall.storeList.msg.copyURL"));
  }

  //문의하기 스크롤 이동
  function goToInquiry() {
    const storeDetail = document.getElementById("storeDetail");
    const scrollHeight =
      storeDetail.scrollHeight - storeDetail.offsetHeight - 100;
    storeDetail.scrollTo(0, scrollHeight);
  }

  //리뷰 목록 요청(리뷰 등록, 수정 후)
  function requestReviewList() {
    if (selectedStore !== null) {
      SELECT_STORE_REVIEW(selectedStore);
    }
  }

  return (
    <>
      {!isLogiWork && <CommonNav />}
      <StoreReview
        loginInfo={loginInfo}
        storeReviewList={storeReviewList}
        selectedStore={selectedStore}
        requestReviewList={requestReviewList}
      />
      <main
        className={`${
          currentView < 2 ? "d-flex flex-row justify-content-start" : ""
        }`}
        style={{ marginTop: isLogiWork ? 0 : navHeight }}
      >
        {loading && <LoadingUI />}
        {/*창고 리스트 및 요약*/}
        {(isMobileListView || currentView < 2) && (
          <div
            className="position-fixed bg-white shadow-sm overflow_scroll shadow-sm"
            style={{
              height: isLogiWork
                ? "100vh"
                : "calc(100vh - " + navHeight + "px)",
              minWidth: currentView !== 2 ? 350 : "100vw",
              maxWidth: currentView !== 2 ? 400 : "100vw",
              zIndex: 999,
            }}
          >
            <input
              id="store_url"
              className="form-control d-none"
              ref={$store_url}
              disabled
            />

            {!(
              !isStoreListView &&
              selectedStore !== null &&
              currentView !== 2
            ) && (
              <>
                {/*  창고 검색*/}
                <div className="py-1">
                  <div className="p-2 px-3 d-flex flex-row justify-content-between align-items-center">
                    <h4
                      className="p-0 pl-1 mb-0 font-weight-900 text-freiscop"
                      style={
                        currentView === 2 && selectedStore === null
                          ? { marginLeft: 52, marginTop: 6 }
                          : {}
                      }
                    >
                      {t("storeMall.logiKeep").toUpperCase()}
                    </h4>
                    <a
                      href="https://gbts-invoice.s3.ap-northeast-2.amazonaws.com/talk/GBTS-%EB%B3%B4%EC%84%B8%EC%B0%BD%EA%B3%A0%EB%AA%B0+%EC%86%8C%EA%B0%9C%EC%84%9C(2022.03.16).pdf"
                      target="_blank"
                      className="btn btn-sm btn-outline-info border-freiscop text-freiscop font-size-09 font-weight-bold"
                    >
                      {t("storeMall.storeList.manual")}
                    </a>
                  </div>

                  <div className="rounded bg-freiscop-05 p-1 px-2 mx-3 d-flex flex-row align-items-center">
                    <input
                      className="flex-fill bg-transparent border-0"
                      placeholder={t("storeMall.storeList.searchPlaceholder")}
                      ref={$search_word}
                      onKeyPress={(e) => {
                        if (e.charCode === 13) {
                          searchStore();
                        } else {
                          window.searchKeyword = {
                            keyword: $search_word.current.value.trim(),
                          };
                        }
                      }}
                    />
                    <h6
                      className="p-0 pl-3 m-0 cursor_pointer text-secondary"
                      onClick={searchStore}
                    >
                      <i className="fa-solid fa-magnifying-glass" />
                    </h6>
                  </div>
                </div>
                {/*  창고리스트*/}
                <StoreList
                  loading={loading}
                  storeList={storeList}
                  isStoreListView={isStoreListView}
                  showSelectedStoreDetail={showSelectedStoreDetail}
                />
              </>
            )}
            {!isStoreListView &&
              selectedStore !== null &&
              currentView !== 2 && (
                <StoreSummaryData
                  selectedStore={selectedStore}
                  copyUrl={copyUrl}
                  openImageSlide={openImageSlide}
                  closeSummaryStoreData={closeSummaryStoreData}
                />
              )}
          </div>
        )}

        {/*지도*/}
        <div className="flex-fill position-relative">
          <StoreMallMap
            selectedStore={selectedStore}
            isSearchWord={isSearchWord}
            setWordFilter={setWordFilter}
            changeStoreList={changeStoreList}
            clickMapMaker={clickMapMaker}
            setLoading={setLoading}
            currentView={currentView}
            isLogiWork={isLogiWork}
          />

          {currentView === 2 && selectedStore === null && (
            <div
              className="position-absolute btn_1 px-3 font-size-09"
              style={{
                zIndex: 9999999,
                top: 13,
                left: 17,
                height: 28,
              }}
              onClick={() => {
                setSelectedStore(null);
                setIsMobileListView(!isMobileListView);
              }}
            >
              {!isMobileListView ? (
                <i className="fa-solid fa-bars" />
              ) : (
                <i className="fa-solid fa-map" />
              )}
            </div>
          )}
          {isImageSlideView && selectedStore !== null && (
            <StoreImageSlide
              selectedStore={selectedStore}
              imageSlideIndex={imageSlideIndex}
              changeImageSlideIndex={changeImageSlideIndex}
              closeImageSlide={closeImageSlide}
            />
          )}
        </div>
        {/*창고 상세 정보 및 문의하기*/}
        {selectedStore !== null && (
          <StoreDetailContact
            loginInfo={loginInfo}
            currentView={currentView}
            navHeight={navHeight}
            selectedStore={selectedStore}
            isLogiWork={isLogiWork}
            clearSelectedStore={clearSelectedStore}
            copyUrl={copyUrl}
            goToInquiry={goToInquiry}
            setIsContactView={setIsContactView}
            isContactView={isContactView}
            openImageSlide={openImageSlide}
            INSERT_STORE_INQUIRY={INSERT_STORE_INQUIRY}
            storeReviewList={storeReviewList}
          />
        )}
      </main>
    </>
  );
}
